// extracted by mini-css-extract-plugin
export default {"base":"app_base__JsQB-","initializing":"app_initializing__h4mUU","container":"app_container__XBPJS","doodads":"app_doodads__77ZZ1","bgshimmer":"app_bgshimmer__ZDLvY"};